<mat-horizontal-stepper linear="true" #stepper>
  <mat-step [stepControl]="formStepeOne">
    <form [formGroup]="formStepeOne">
      @if (!mobile) {
      <ng-template class="font" matStepLabel>Equipo</ng-template>
      } @else{
      <div class="mobile-step-title">Selección de equipo</div>
      }
      <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 5px;
        ">
        <app-button-label [labels]="labels"> </app-button-label>
        <div style="width: 100%; padding: 10px">
          <data-table title="" [columns]="columnasEquipos" [configuration]="configurationEquipos"
            [reloadTable]="recargarTablaEquipos" (clickRow)="clickFilaEquipos($event)" [params]="[]"
            [url]="urlTablaEquipos">
          </data-table>
        </div>

        <div style="display: none">
          <mat-form-field>
            <input autocomplete="off" type="text" formControlName="idEquipo" matInput required />
          </mat-form-field>
        </div>

        @if (hasInitialSelection) {
        <button matStepperNext style="width: 70%; margin: 15px 0 15px 0" color="primary"
          class="button-save mat-elevation-z5" mat-raised-button>
          Continuar
        </button>
        }

      </div>
    </form>
  </mat-step>

  <mat-step>

    @if (!mobile) {
    <ng-template class="font" matStepLabel>Actividad</ng-template>
    } @else{
    <div class="mobile-step-title">Actividad</div>
    }

    <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 5px;
      ">
      <app-button-label [labels]="labels"> </app-button-label>
      <div style="width: 100%; padding: 10px">
        <data-table [title]="titleSolicitudesMtto" [columns]="columnasSolicitudesMtto"
          [configuration]="configurationSolicitudesMtto" [reloadTable]="recargarTablaSolicitudesMtto" [params]="[]"
          [url]="urlTablaSolicitudesMtto" (clickRow)="clickFilaSolicitudesMtto($event)"
          (selected)="seleccionadosSolicitudesMtto($event)">
        </data-table>
      </div>

      <button matStepperNext style="width: 70%; margin: 5px 0 15px 0" color="primary"
        class="button-save mat-elevation-z5" mat-raised-button>
        Aceptar
      </button>
    </div>
  </mat-step>

  <!-- Recursos  -->
  @if (inventoryModule && comboItemLength > 0) {
  <mat-step>

    @if (!mobile) {
    <ng-template matStepLabel>Recursos</ng-template>
    } @else{
    <div class="mobile-step-title">Recursos</div>
    }


    <app-button-label [labels]="labels"> </app-button-label>
    <app-handler-items (listItemComplete)="saveResources($event)" (comboItemLength)="comboItemsLength($event)"
      [titleDialog]="'Recursos'" [headerDetails]="false" [acceptButton]="true" [initializeEmptyItem]="true"
      [urlItemCombo]="urlGetItems">
    </app-handler-items>
  </mat-step>
  }

  <mat-step>
    <ng-template class="font" matStepLabel>Formulario</ng-template>

    @if (!mobile) {
    <ng-template matStepLabel>Formulario</ng-template>
    } @else{
    <div class="mobile-step-title">Formulario</div>
    }

    <form [formGroup]="formStepeThree" (ngSubmit)="formStepeThree.valid ? enviar() : errorMessage()">
      <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 10px;
        ">
        <app-button-label [labels]="labels"> </app-button-label>

        <app-button-label [labels]="labelActivity"> </app-button-label>

        <div class="first-row" style="width: 100%">
          <div class="row-item">
            <combos [dataCombos]="typeOfMaintenance" [configuration]="combosTypeOfMaintenance" [required]="true"
              (changeOption)="changesTypeOfMaintenance($event)">
            </combos>
          </div>

          <div class="row-item">
            <mat-form-field [appOpenDatepickerOnClick]="executionDate">
              <mat-label>Fecha ejecucion</mat-label>
              <input matInput [matDatepicker]="executionDate" autocomplete="off" matInput required
                formControlName="executionDate" required />
              <mat-datepicker-toggle matIconSuffix [for]="executionDate">
              </mat-datepicker-toggle>
              <mat-datepicker #executionDate [touchUi]="mobile ? true : false"></mat-datepicker>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="default-row" style="width: 100%">
          @if (!inventoryModule) {
          <div class="row-item">
            <mat-form-field>
              <mat-label>Recursos</mat-label>
              <input autocomplete="off" type="text" formControlName="resources" matInput #recursos maxlength="255"
                placeholder="Recursos" />
              <mat-hint>{{ recursos.value.length }}/255</mat-hint>
            </mat-form-field>
          </div>
          }

          <div class="row-item">
            <mat-form-field>
              <mat-label>Descripción</mat-label>
              <input autocomplete="off" type="text" matInput formControlName="description" placeholder="Descripción"
                #descripcion maxlength="255" />
              <mat-hint>{{ descripcion.value.length }}/255</mat-hint>
            </mat-form-field>
          </div>
        </div>

        @if (buttonActive) {
        <button [disabled]="
            !formStepeThree.get('maintenanceType').value ||
            !formStepeThree.get('executionDate').value
          " style="width: 70%; margin: 15px 0 10px 0" color="primary" class="button-save mat-elevation-z5"
          mat-raised-button type="submit">
          Enviar
        </button>
        }
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>